import { useDispatch } from 'react-redux'

import type { AppDispatch } from '@web/app/store'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
